"use client"

import Lottie from "lottie-react"
import animationData from "./animationData.json"
import { mergeClassNames } from "@/helpers/mergeClassNames"

export const Loader = ({ className }: { className?: string }) => {
  return (
    <div
      className={mergeClassNames(
        "flex flex-col grow items-center justify-center",
        className,
      )}
    >
      <Lottie
        animationData={animationData}
        loop={true}
        className="w-24 h-24 opacity-70"
      />
    </div>
  )
}
